export const DOWNLOAD_RESULT_PDF_FILE_REQUEST = 'DOWNLOAD_RESULT_PDF_FILE_REQUEST';

export const downloadResultPdfFileRequest = ( id ) => ({
    type: DOWNLOAD_RESULT_PDF_FILE_REQUEST,
    payload: { id }
});
